import { Link as BaseRouterLink } from 'react-router-dom';
import { Link as StencilLink } from '@amzn/stencil-react-components/link';

const RouterLink = StencilLink.withComponent(BaseRouterLink);

RouterLink.defaultProps = {
  ...StencilLink.defaultProps,
};

export default RouterLink;
